import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
 
const ActionButton = ({ label, onClick, ...props }) => (
  <Button
    fullWidth
    onClick={onClick}
    variant="contained"
    disableElevation
    sx={{
      borderRadius: 1,
      background: 'linear-gradient(180deg, #E8E8E8 0%, #D9D9D9 100%)',
      color: '#111315',
      border: '1px solid rgba(14,16,20,0.08)',
      fontSize: 12,
      fontWeight: 600,
      textTransform: 'none',
      letterSpacing: '0.04em',
      py: 1,
      boxShadow: '0 12px 28px rgba(0,0,0,0.2)',
      '&:hover': {
        boxShadow: '0 16px 36px rgba(0,0,0,0.24)',
        transform: 'translateY(-1px)',
      },
      '&:active': {
        boxShadow: '0 10px 20px rgba(0,0,0,0.22)',
      },
      ...props.sx,
    }}
    {...props}
  >
    {label}
  </Button>
);
 
 
ActionButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};
 
export default ActionButton;